import { Data2, dateToString } from '../../../features/data-types'
import { O } from '../../../features/ui'
import { TableName } from '../../../tables'
import { SaleOperation, SalePaymentItem } from '../state/types'
import { useHoardBuilders } from './hoardBuilders'
import { useSaleBuilders } from './saleBuilders'

export const useSaleOperationBuilders = () => {
    const { buildSale } = useSaleBuilders()
    const { buildHoard } = useHoardBuilders()

    const buildSaleOperation = (
        table: TableName,
        data: Data2
    ): SaleOperation => {
        const buildOperation = table === TableName.SALE_ORDERS ? buildSale : buildHoard
        return buildOperation(data) as SaleOperation
    }
    
    const buildSalePaymentItem = (data: Data2): SalePaymentItem => {
        const {
            paymentTypeId,
            destinationId,
            creditInFavor,
            isRounding,
            amount,
            receiptUrl,
            paymentDate
        } = data
        const salePaymentItem: SalePaymentItem = {
            paymentTypeId: paymentTypeId as O<string>,
            destinationId: destinationId as O<string>,
            creditInFavor: !!creditInFavor,
            isRounding: !!isRounding,
            amount: amount! as number,
            paymentDate: dateToString(paymentDate || new Date())!,
            receiptUrl: receiptUrl as O<string>,
        }

        return salePaymentItem
    }

    return {
        buildSaleOperation,
        buildSalePaymentItem
    }
}
